<!-- components/AutocompleteInput.vue -->
<template>
 <div class="position-relative">
    <label v-if="label" class="font-weight-semibold d-block mb-2">{{ label }}</label>
    <div class="position-relative">
      <!-- ICON SEARCH -->
      <img 
        src="@/assets/icon/search-icon.png"
        alt="Search"
        class="search-icon"
      />

      <!-- INPUT -->
      <input
        type="text"
        class="form-control pl-5 rounded-custom"
        :placeholder="placeholder || 'Cari nama part'"
        v-model="inputValue"
        @focus="showDropdown = true"
        @blur="hideDropdown"
        ref="inputRef"
      />

      <!-- DROPDOWN -->
      <ul
        v-if="showDropdown && sparepartList.length"
        class="list-group position-absolute w-100 mt-1 dropdown-list"
      >
        <li
          v-for="(item, index) in sparepartList"
          :key="index"
          class="list-group-item list-group-item-action d-flex align-items-center"
          style="cursor: pointer;"
          @mousedown.prevent="selectItem(item)"
        >
          <img 
            src="@/assets/icon/search-icon.png" 
            alt="Search" 
            style="width: 16px; height: 16px; margin-right: 10px;"
          />
          {{ item.itemName }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'

export default {
  name: "AutocompleteInput",
  props: {
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: "Cari nama part"
    },
    selectedPart : {
      type: Array,
      required: true
    },
    modelValue: {
      type: String,
      default: ""
    },
    warehouse:{
      type: String,
      default:''
    }
  },
  data() {
    return {
      inputValue: this.modelValue,
      showDropdown: false,
      sparepartList : [],
    };
  },
  watch: {
    modelValue(newVal) {
      this.inputValue = newVal;
    },
    inputValue(newVal) {
      this.$emit("update:modelValue", newVal);
      this.debouncedSearch()
    }
  },
  methods: {
    searchPart() {
      if(this.inputValue){
        this.sparepartList = [];
        this.$http.post(process.env.ASSEMBLY_GET_SPAREPART, {
          name : this.inputValue,
          warehouse: this.warehouse
          }, {
            headers: {
              'Asani-Token': localStorage.getItem('jwt')
            }
        })
        .then(res => {
          if (res.data.status = 200) {
            this.sparepartList = res.data.content
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
      }
      
    },
    selectItem(item) {
      this.inputValue = '';
      this.selectedPart.push({...item, code : `${item.itemCode} - ${this.selectedPart.length}`})
      this.showDropdown = false;
      this.sparepartList = [];
      // Hilangkan fokus dari input
      this.$refs.inputRef.blur()
    },
    hideDropdown() {
      setTimeout(() => {
        this.showDropdown = false;
      }, 100);
    }
  },
  created() {
     // Buat versi debounce dari fungsi fetchData
    this.debouncedSearch = debounce(this.searchPart, 500)
  }
};
</script>

<style scoped>
.search-icon {
  position: absolute;
  top: 50%;
  left: 12px;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  pointer-events: none;
}

/* Custom rounded style for Bootstrap 4 */
.rounded-custom {
  border-radius: 0.5rem;
}

/* Custom dropdown styling */
.dropdown-list {
  max-height: 200px;
  overflow-y: auto;
  border-radius: 0.5rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  z-index: 1000; /* Because Bootstrap 4 doesn't have z-1 */
}

.font-weight-semibold {
  font-weight: 450;
}
ul.list-group {
  border: 1px solid #dee2e6;
  border-top: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Assembly/CustomComponent/AutocompleteInput.vue